/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AdminSchedulingLinkId,
  AvailabilityFeature,
  AvailableMeetingType,
  CheckFlexibleLiveAvailabilityResponse,
  CreateMeetingAttemptRequest,
  CustomRules,
  CustomSchedule1,
  EventPriorityScheduling,
  EventWithPriority,
  FlexibleRoundRobinMeetingStartTimes,
  FlexibleRoundRobinMeetingStartTimesRequest,
  MapString,
  MapStringEventPriorityScheduling,
  MapStringSeriesPriorityScheduling,
  MapUserIdUserAvailabilityToggleResponse,
  MeetingAttempt,
  MeetingAttemptReservationResultMeetingReservation,
  MeetingAttemptResponse,
  MeetingLimitLinkSourceOrNoSource,
  MeetingLimitRequest,
  MeetingLimitResponse,
  MeetingReservation,
  MultipleRoundRobinMeetingStartTimes,
  MultipleRoundRobinMeetingStartTimesRequest,
  OpenMeetingAttemptRequest,
  OpenMeetingAttemptResult,
  PrioritySchedulingEventsRequest,
  PrioritySchedulingEventsResponse,
  PrioritySchedulingSeriesRequest,
  PrioritySchedulingSeriesResponse,
  ReserveMeetingAttemptRequest,
  ReserveTimeSlotRequest,
  Schedule,
  ScheduleDraftView,
  SchedulePublishedViewCustomSchedule,
  SchedulePublishedViewDefaultSchedule,
  SchedulePublishedViewSchedule,
  SeriesPriorityScheduling,
  StrictRoundRobinMeetingStartTimes,
  StrictRoundRobinMeetingStartTimesRequest,
  SuggestedMeetingStartTimes,
  TimeInterval,
  UpdateAvailabilityToggleRequest,
  UserAvailabilityMap,
  UserAvailabilityToggleResponse,
  UsersAvailabilityMap,
  UsersCombinedAvailableMeetingStartTimesRequest,
  UsersCombinedMeetingStartTimes,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "user-availability";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description Attempts to get the available slots of the assignees and the additional required attendees for a flexible round robin meeting
   *
   * @tags Availability
   * @name GetAvailabilitiesForFlexibleRoundRobin
   * @request PUT:/v1/public/tenant/{tenantId}/round-robin/flexible/slots
   */
  getAvailabilitiesForFlexibleRoundRobin = (
    tenantId: string,
    data: FlexibleRoundRobinMeetingStartTimesRequest,
    query?: {
      /** @default [] */
      feature?: AvailabilityFeature[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      FlexibleRoundRobinMeetingStartTimes,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/round-robin/flexible/slots`,
      method: "PUT",
      query: query,
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getAvailabilitiesForFlexibleRoundRobin */
  getAvailabilitiesForFlexibleRoundRobinPathGetter = (
    tenantId: string,
    query?: {
      /** @default [] */
      feature?: AvailabilityFeature[];
    },
  ) => this.getServicePath(`/v1/public/tenant/${tenantId}/round-robin/flexible/slots`, query);

  /**
   * @description Attempts to get the available slots multiple distribution attendees and the additional required attendees for a flexible round robin meeting
   *
   * @tags Availability
   * @name GetAvailabilitiesForMultipleRoundRobin
   * @request PUT:/v1/public/tenant/{tenantId}/round-robin/multiple/slots
   */
  getAvailabilitiesForMultipleRoundRobin = (
    tenantId: string,
    data: MultipleRoundRobinMeetingStartTimesRequest,
    query?: {
      /** @default [] */
      feature?: AvailabilityFeature[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MultipleRoundRobinMeetingStartTimes,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/round-robin/multiple/slots`,
      method: "PUT",
      query: query,
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getAvailabilitiesForMultipleRoundRobin */
  getAvailabilitiesForMultipleRoundRobinPathGetter = (
    tenantId: string,
    query?: {
      /** @default [] */
      feature?: AvailabilityFeature[];
    },
  ) => this.getServicePath(`/v1/public/tenant/${tenantId}/round-robin/multiple/slots`, query);

  /**
   * @description Attempts to pick first assignee who has connected calendar when they're the host + find the available slots for this assignee and the additional required attendees for a strict round robin meeting
   *
   * @tags Availability
   * @name GetAvailabilitiesForStrictRoundRobin
   * @request PUT:/v1/public/tenant/{tenantId}/round-robin/strict/slots
   */
  getAvailabilitiesForStrictRoundRobin = (
    tenantId: string,
    data: StrictRoundRobinMeetingStartTimesRequest,
    query?: {
      /** @default [] */
      feature?: AvailabilityFeature[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      StrictRoundRobinMeetingStartTimes,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/round-robin/strict/slots`,
      method: "PUT",
      query: query,
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getAvailabilitiesForStrictRoundRobin */
  getAvailabilitiesForStrictRoundRobinPathGetter = (
    tenantId: string,
    query?: {
      /** @default [] */
      feature?: AvailabilityFeature[];
    },
  ) => this.getServicePath(`/v1/public/tenant/${tenantId}/round-robin/strict/slots`, query);

  /**
   * @description Attempts to get the calendar availabilities of the users
   *
   * @tags Availability
   * @name GetUsersAvailabilities
   * @request PUT:/v1/public/tenant/{tenantId}/users/combined/slots
   */
  getUsersAvailabilities = (
    tenantId: string,
    data: UsersCombinedAvailableMeetingStartTimesRequest,
    query?: {
      /** @default [] */
      feature?: AvailabilityFeature[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      UsersCombinedMeetingStartTimes,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/users/combined/slots`,
      method: "PUT",
      query: query,
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getUsersAvailabilities */
  getUsersAvailabilitiesPathGetter = (
    tenantId: string,
    query?: {
      /** @default [] */
      feature?: AvailabilityFeature[];
    },
  ) => this.getServicePath(`/v1/public/tenant/${tenantId}/users/combined/slots`, query);

  /**
   * @description Attempts to get start and end times of the period when the meeting can be scheduled
   *
   * @tags Availability
   * @name GetMeetingsAvailabilitySpan
   * @request GET:/v1/public/tenant/{tenantId}/slots/span
   */
  getMeetingsAvailabilitySpan = (
    tenantId: string,
    query: {
      /** @default [] */
      feature?: AvailabilityFeature[];
      /** @format uuid */
      meetingTypeId: string;
      meetingTypeVersion: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      TimeInterval,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/slots/span`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getMeetingsAvailabilitySpan */
  getMeetingsAvailabilitySpanPathGetter = (
    tenantId: string,
    query: {
      /** @default [] */
      feature?: AvailabilityFeature[];
      /** @format uuid */
      meetingTypeId: string;
      meetingTypeVersion: string;
    },
  ) => this.getServicePath(`/v1/public/tenant/${tenantId}/slots/span`, query);

  /**
   * @description Reserve a timeslot to prevent it from being double booked by CP. By default it checks if slot can be reserved which differs from the old reservation endpoint
   *
   * @tags Availability
   * @name PostApiV1PublicTenantTenantidUsersSlots
   * @request POST:/v1/public/tenant/{tenantId}/users/slots
   * @deprecated
   */
  postApiV1PublicTenantTenantidUsersSlots = (
    tenantId: string,
    data: ReserveTimeSlotRequest,
    query?: {
      /** @default [] */
      feature?: AvailabilityFeature[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MeetingReservation,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/users/slots`,
      method: "POST",
      query: query,
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for postApiV1PublicTenantTenantidUsersSlots */
  postApiV1PublicTenantTenantidUsersSlotsPathGetter = (
    tenantId: string,
    query?: {
      /** @default [] */
      feature?: AvailabilityFeature[];
    },
  ) => this.getServicePath(`/v1/public/tenant/${tenantId}/users/slots`, query);

  /**
   * @description delete reservation for a timeslot
   *
   * @tags Availability
   * @name DeleteTimeSlotReservation
   * @request DELETE:/v1/public/tenant/{tenantId}/slots/{reservationId}
   */
  deleteTimeSlotReservation = (
    tenantId: string,
    reservationId: string,
    query?: {
      /** @default [] */
      feature?: AvailabilityFeature[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/slots/${reservationId}`,
      method: "DELETE",
      query: query,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteTimeSlotReservation */
  deleteTimeSlotReservationPathGetter = (
    tenantId: string,
    reservationId: string,
    query?: {
      /** @default [] */
      feature?: AvailabilityFeature[];
    },
  ) => this.getServicePath(`/v1/public/tenant/${tenantId}/slots/${reservationId}`, query);

  /**
   * @description Attempts to get timezone of the user synced from external calendar
   *
   * @tags Timezone
   * @name GetUserSyncedTimezone
   * @request GET:/v1/public/tenant/{tenantId}/user/{userId}/timezoneSynced
   */
  getUserSyncedTimezone = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      AdminSchedulingLinkId,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/user/${userId}/timezoneSynced`,
      method: "GET",
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getUserSyncedTimezone */
  getUserSyncedTimezonePathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/public/tenant/${tenantId}/user/${userId}/timezoneSynced`);

  /**
   * @description Attempts to get user timezone from default availability schedule
   *
   * @tags Timezone
   * @name GetUserDefaultTimezone
   * @request GET:/v1/public/tenant/{tenantId}/user/{userId}/timezoneDefault
   */
  getUserDefaultTimezone = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      AdminSchedulingLinkId,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/user/${userId}/timezoneDefault`,
      method: "GET",
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getUserDefaultTimezone */
  getUserDefaultTimezonePathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/public/tenant/${tenantId}/user/${userId}/timezoneDefault`);

  /**
   * No description
   *
   * @tags Priority Scheduling
   * @name GetPrioritySchedulingConfigurationByEventId
   * @request GET:/v1/tenant/{tenantId}/user/{userId}/event/{eventId}/priority-scheduling-config
   * @secure
   */
  getPrioritySchedulingConfigurationByEventId = (
    tenantId: string,
    userId: string,
    eventId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      EventPriorityScheduling,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/event/${eventId}/priority-scheduling-config`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getPrioritySchedulingConfigurationByEventId */
  getPrioritySchedulingConfigurationByEventIdPathGetter = (tenantId: string, userId: string, eventId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/event/${eventId}/priority-scheduling-config`);

  /**
   * @description Update priority scheduling configuration
   *
   * @tags Priority Scheduling
   * @name PutApiV1TenantTenantidUserUseridEventEventidPrioritySchedulingConfig
   * @request PUT:/v1/tenant/{tenantId}/user/{userId}/event/{eventId}/priority-scheduling-config
   * @secure
   */
  putApiV1TenantTenantidUserUseridEventEventidPrioritySchedulingConfig = (
    tenantId: string,
    userId: string,
    eventId: string,
    data: EventPriorityScheduling,
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/event/${eventId}/priority-scheduling-config`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for putApiV1TenantTenantidUserUseridEventEventidPrioritySchedulingConfig */
  putApiV1TenantTenantidUserUseridEventEventidPrioritySchedulingConfigPathGetter = (
    tenantId: string,
    userId: string,
    eventId: string,
  ) => this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/event/${eventId}/priority-scheduling-config`);

  /**
   * No description
   *
   * @tags Priority Scheduling
   * @name ConfigurePrioritySchedulingForTheEvent
   * @request POST:/v1/tenant/{tenantId}/user/{userId}/event/{eventId}/priority-scheduling-config
   * @secure
   */
  configurePrioritySchedulingForTheEvent = (
    tenantId: string,
    userId: string,
    eventId: string,
    data: EventPriorityScheduling,
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/event/${eventId}/priority-scheduling-config`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for configurePrioritySchedulingForTheEvent */
  configurePrioritySchedulingForTheEventPathGetter = (tenantId: string, userId: string, eventId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/event/${eventId}/priority-scheduling-config`);

  /**
   * @description Attempts to delete priority scheduling configuration
   *
   * @tags Priority Scheduling
   * @name DeletePrioritySchedulingConfiguration
   * @request DELETE:/v1/tenant/{tenantId}/user/{userId}/event/{eventId}/priority-scheduling-config
   * @secure
   */
  deletePrioritySchedulingConfiguration = (
    tenantId: string,
    userId: string,
    eventId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/event/${eventId}/priority-scheduling-config`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deletePrioritySchedulingConfiguration */
  deletePrioritySchedulingConfigurationPathGetter = (tenantId: string, userId: string, eventId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/event/${eventId}/priority-scheduling-config`);

  /**
   * No description
   *
   * @tags Priority Scheduling
   * @name GetPrioritySchedulingConfigurationByEventSeriesId
   * @request GET:/v1/tenant/{tenantId}/user/{userId}/eventSeries/{eventSeriesId}/priority-scheduling-config
   * @secure
   */
  getPrioritySchedulingConfigurationByEventSeriesId = (
    tenantId: string,
    userId: string,
    eventSeriesId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      SeriesPriorityScheduling,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/eventSeries/${eventSeriesId}/priority-scheduling-config`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getPrioritySchedulingConfigurationByEventSeriesId */
  getPrioritySchedulingConfigurationByEventSeriesIdPathGetter = (
    tenantId: string,
    userId: string,
    eventSeriesId: string,
  ) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/user/${userId}/eventSeries/${eventSeriesId}/priority-scheduling-config`,
    );

  /**
   * @description Update priority scheduling configuration
   *
   * @tags Priority Scheduling
   * @name PutApiV1TenantTenantidUserUseridEventseriesEventseriesidPrioritySchedulingConfig
   * @request PUT:/v1/tenant/{tenantId}/user/{userId}/eventSeries/{eventSeriesId}/priority-scheduling-config
   * @secure
   */
  putApiV1TenantTenantidUserUseridEventseriesEventseriesidPrioritySchedulingConfig = (
    tenantId: string,
    userId: string,
    eventSeriesId: string,
    data: SeriesPriorityScheduling,
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/eventSeries/${eventSeriesId}/priority-scheduling-config`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for putApiV1TenantTenantidUserUseridEventseriesEventseriesidPrioritySchedulingConfig */
  putApiV1TenantTenantidUserUseridEventseriesEventseriesidPrioritySchedulingConfigPathGetter = (
    tenantId: string,
    userId: string,
    eventSeriesId: string,
  ) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/user/${userId}/eventSeries/${eventSeriesId}/priority-scheduling-config`,
    );

  /**
   * No description
   *
   * @tags Priority Scheduling
   * @name ConfigurePrioritySchedulingForTheEventSeries
   * @request POST:/v1/tenant/{tenantId}/user/{userId}/eventSeries/{eventSeriesId}/priority-scheduling-config
   * @secure
   */
  configurePrioritySchedulingForTheEventSeries = (
    tenantId: string,
    userId: string,
    eventSeriesId: string,
    data: SeriesPriorityScheduling,
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/eventSeries/${eventSeriesId}/priority-scheduling-config`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for configurePrioritySchedulingForTheEventSeries */
  configurePrioritySchedulingForTheEventSeriesPathGetter = (tenantId: string, userId: string, eventSeriesId: string) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/user/${userId}/eventSeries/${eventSeriesId}/priority-scheduling-config`,
    );

  /**
   * @description Attempts to delete priority scheduling configuration
   *
   * @tags Priority Scheduling
   * @name DeletePrioritySchedulingConfigurationForSeriesOfEvents
   * @request DELETE:/v1/tenant/{tenantId}/user/{userId}/eventSeries/{eventSeriesId}/priority-scheduling-config
   * @secure
   */
  deletePrioritySchedulingConfigurationForSeriesOfEvents = (
    tenantId: string,
    userId: string,
    eventSeriesId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/eventSeries/${eventSeriesId}/priority-scheduling-config`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deletePrioritySchedulingConfigurationForSeriesOfEvents */
  deletePrioritySchedulingConfigurationForSeriesOfEventsPathGetter = (
    tenantId: string,
    userId: string,
    eventSeriesId: string,
  ) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/user/${userId}/eventSeries/${eventSeriesId}/priority-scheduling-config`,
    );

  /**
   * @description Find priority scheduling configuration by event ids. If one of event ids is not found, it will be omitted from the result. If no events are found, returns 404
   *
   * @tags Priority Scheduling
   * @name GetApiV1TenantTenantidUserUseridPrioritySchedulingConfigBatch
   * @request GET:/v1/tenant/{tenantId}/user/{userId}/priority-scheduling-config-batch
   * @deprecated
   * @secure
   */
  getApiV1TenantTenantidUserUseridPrioritySchedulingConfigBatch = (
    tenantId: string,
    userId: string,
    query?: {
      /** @minItems 1 */
      eventId?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MapStringEventPriorityScheduling,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/priority-scheduling-config-batch`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidUserUseridPrioritySchedulingConfigBatch */
  getApiV1TenantTenantidUserUseridPrioritySchedulingConfigBatchPathGetter = (
    tenantId: string,
    userId: string,
    query?: {
      /** @minItems 1 */
      eventId?: string[];
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/priority-scheduling-config-batch`, query);

  /**
   * @description Find priority scheduling configuration by event ids. If one of event ids is not found, it will be omitted from the result. If no events are found, returns 404
   *
   * @tags Priority Scheduling
   * @name PutApiV1TenantTenantidPrioritySchedulingConfigBatch
   * @request PUT:/v1/tenant/{tenantId}/priority-scheduling-config-batch
   * @secure
   */
  putApiV1TenantTenantidPrioritySchedulingConfigBatch = (
    tenantId: string,
    data: PrioritySchedulingEventsRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      PrioritySchedulingEventsResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/priority-scheduling-config-batch`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for putApiV1TenantTenantidPrioritySchedulingConfigBatch */
  putApiV1TenantTenantidPrioritySchedulingConfigBatchPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/priority-scheduling-config-batch`);

  /**
   * @description Find priority scheduling configuration by event ids. If one of event ids is not found, it will be omitted from the result. If no events are found, returns 404
   *
   * @tags Priority Scheduling
   * @name GetApiV1TenantTenantidUserUseridPrioritySchedulingSeriesConfigBatch
   * @request GET:/v1/tenant/{tenantId}/user/{userId}/priority-scheduling-series-config-batch
   * @deprecated
   * @secure
   */
  getApiV1TenantTenantidUserUseridPrioritySchedulingSeriesConfigBatch = (
    tenantId: string,
    userId: string,
    query?: {
      /** @minItems 1 */
      eventSeriesId?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MapStringSeriesPriorityScheduling,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/priority-scheduling-series-config-batch`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidUserUseridPrioritySchedulingSeriesConfigBatch */
  getApiV1TenantTenantidUserUseridPrioritySchedulingSeriesConfigBatchPathGetter = (
    tenantId: string,
    userId: string,
    query?: {
      /** @minItems 1 */
      eventSeriesId?: string[];
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/priority-scheduling-series-config-batch`, query);

  /**
   * @description Find priority scheduling configuration by event ids. If one of event ids is not found, it will be omitted from the result. If no events are found, returns 404
   *
   * @tags Priority Scheduling
   * @name PutApiV1TenantTenantidPrioritySchedulingSeriesConfigBatch
   * @request PUT:/v1/tenant/{tenantId}/priority-scheduling-series-config-batch
   * @secure
   */
  putApiV1TenantTenantidPrioritySchedulingSeriesConfigBatch = (
    tenantId: string,
    data: PrioritySchedulingSeriesRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      PrioritySchedulingSeriesResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/priority-scheduling-series-config-batch`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for putApiV1TenantTenantidPrioritySchedulingSeriesConfigBatch */
  putApiV1TenantTenantidPrioritySchedulingSeriesConfigBatchPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/priority-scheduling-series-config-batch`);

  /**
   * No description
   *
   * @tags Priority Scheduling
   * @name GetCustomPrioritySchedulingConfiguration
   * @request GET:/v1/tenant/{tenantId}/user/{userId}/priority-scheduling-config/custom-rules
   * @secure
   */
  getCustomPrioritySchedulingConfiguration = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      CustomRules,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/priority-scheduling-config/custom-rules`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getCustomPrioritySchedulingConfiguration */
  getCustomPrioritySchedulingConfigurationPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/priority-scheduling-config/custom-rules`);

  /**
   * No description
   *
   * @tags Priority Scheduling
   * @name UpdateCustomPrioritySchedulingConfiguration
   * @request PUT:/v1/tenant/{tenantId}/user/{userId}/priority-scheduling-config/custom-rules
   * @secure
   */
  updateCustomPrioritySchedulingConfiguration = (
    tenantId: string,
    userId: string,
    data: CustomRules,
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/priority-scheduling-config/custom-rules`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for updateCustomPrioritySchedulingConfiguration */
  updateCustomPrioritySchedulingConfigurationPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/priority-scheduling-config/custom-rules`);

  /**
   * No description
   *
   * @tags Priority Scheduling
   * @name CreateCustomPrioritySchedulingConfiguration
   * @request POST:/v1/tenant/{tenantId}/user/{userId}/priority-scheduling-config/custom-rules
   * @secure
   */
  createCustomPrioritySchedulingConfiguration = (
    tenantId: string,
    userId: string,
    data: CustomRules,
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/priority-scheduling-config/custom-rules`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for createCustomPrioritySchedulingConfiguration */
  createCustomPrioritySchedulingConfigurationPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/priority-scheduling-config/custom-rules`);

  /**
   * No description
   *
   * @tags Priority Scheduling
   * @name DeleteCustomPrioritySchedulingConfiguration
   * @request DELETE:/v1/tenant/{tenantId}/user/{userId}/priority-scheduling-config/custom-rules
   * @secure
   */
  deleteCustomPrioritySchedulingConfiguration = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/priority-scheduling-config/custom-rules`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteCustomPrioritySchedulingConfiguration */
  deleteCustomPrioritySchedulingConfigurationPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/priority-scheduling-config/custom-rules`);

  /**
   * No description
   *
   * @tags Priority Scheduling
   * @name GetTheListOfEventsWithPrioritySchedulingConfiguration
   * @request GET:/v1/tenant/{tenantId}/user/{userId}/events/priority-scheduling-config
   * @secure
   */
  getTheListOfEventsWithPrioritySchedulingConfiguration = (
    tenantId: string,
    userId: string,
    query: {
      /** @format date-time */
      startTime: string;
      duration: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      EventWithPriority[],
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/events/priority-scheduling-config`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getTheListOfEventsWithPrioritySchedulingConfiguration */
  getTheListOfEventsWithPrioritySchedulingConfigurationPathGetter = (
    tenantId: string,
    userId: string,
    query: {
      /** @format date-time */
      startTime: string;
      duration: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/events/priority-scheduling-config`, query);

  /**
   * @description Attempts to get the calendar suggested slots of the user
   *
   * @tags Suggested Slots
   * @name GetUserSuggestedTimeSlots
   * @request GET:/v1/public/tenant/{tenantId}/user/{userId}/suggested-slots
   */
  getUserSuggestedTimeSlots = (
    tenantId: string,
    userId: string,
    query: {
      /** @default [] */
      feature?: AvailabilityFeature[];
      /**
       * use requiredAttendeeIds instead
       * @deprecated
       */
      userIds?: string[];
      /** @format uuid */
      meetingTypeId: string;
      /** @format date-time */
      intervalStartsAt: string;
      intervalDuration: string;
      guestTimeZone?: string;
      meetingLimit?: MeetingLimitLinkSourceOrNoSource;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      SuggestedMeetingStartTimes,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/user/${userId}/suggested-slots`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getUserSuggestedTimeSlots */
  getUserSuggestedTimeSlotsPathGetter = (
    tenantId: string,
    userId: string,
    query: {
      /** @default [] */
      feature?: AvailabilityFeature[];
      /**
       * use requiredAttendeeIds instead
       * @deprecated
       */
      userIds?: string[];
      /** @format uuid */
      meetingTypeId: string;
      /** @format date-time */
      intervalStartsAt: string;
      intervalDuration: string;
      guestTimeZone?: string;
      meetingLimit?: MeetingLimitLinkSourceOrNoSource;
    },
  ) => this.getServicePath(`/v1/public/tenant/${tenantId}/user/${userId}/suggested-slots`, query);

  /**
   * No description
   *
   * @tags Meeting Attempt
   * @name DeprecatedSince20250714UseGetV2Instead
   * @request GET:/v1/public/tenant/{tenantId}/meeting-attempt/{meetingAttemptId}
   * @deprecated
   */
  deprecatedSince20250714UseGetV2Instead = (tenantId: string, meetingAttemptId: string, params: RequestParams = {}) =>
    this.request<
      MeetingAttemptResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/meeting-attempt/${meetingAttemptId}`,
      method: "GET",
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deprecatedSince20250714UseGetV2Instead */
  deprecatedSince20250714UseGetV2InsteadPathGetter = (tenantId: string, meetingAttemptId: string) =>
    this.getServicePath(`/v1/public/tenant/${tenantId}/meeting-attempt/${meetingAttemptId}`);

  /**
   * No description
   *
   * @tags Meeting Attempt
   * @name DeprecatedSince20250714UseCreateV2Instead
   * @request POST:/v1/tenant/{tenantId}/meeting-attempt
   * @deprecated
   * @secure
   */
  deprecatedSince20250714UseCreateV2Instead = (
    tenantId: string,
    data: CreateMeetingAttemptRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      MeetingAttempt,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/meeting-attempt`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deprecatedSince20250714UseCreateV2Instead */
  deprecatedSince20250714UseCreateV2InsteadPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/meeting-attempt`);

  /**
   * No description
   *
   * @tags Meeting Attempt
   * @name ALinkToAMeetingAttemptWasOpened
   * @request POST:/v1/public/tenant/{tenantId}/meeting-attempt/{meetingAttemptId}/open
   */
  aLinkToAMeetingAttemptWasOpened = (
    tenantId: string,
    meetingAttemptId: string,
    data: OpenMeetingAttemptRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      OpenMeetingAttemptResult,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/meeting-attempt/${meetingAttemptId}/open`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for aLinkToAMeetingAttemptWasOpened */
  aLinkToAMeetingAttemptWasOpenedPathGetter = (tenantId: string, meetingAttemptId: string) =>
    this.getServicePath(`/v1/public/tenant/${tenantId}/meeting-attempt/${meetingAttemptId}/open`);

  /**
   * No description
   *
   * @tags Meeting Attempt
   * @name DeleteMeetingAttempt
   * @request DELETE:/v1/tenant/{tenantId}/meeting-attempt/{meetingAttemptId}
   * @secure
   */
  deleteMeetingAttempt = (tenantId: string, meetingAttemptId: string, params: RequestParams = {}) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/meeting-attempt/${meetingAttemptId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteMeetingAttempt */
  deleteMeetingAttemptPathGetter = (tenantId: string, meetingAttemptId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/meeting-attempt/${meetingAttemptId}`);

  /**
   * No description
   *
   * @tags Meeting Attempt
   * @name ClaimAMeetingAttemptReservationDepreacted
   * @request POST:/v1/public/tenant/{tenantId}/meeting-attempt/{meetingAttemptId}/reservation
   * @deprecated
   */
  claimAMeetingAttemptReservationDepreacted = (
    tenantId: string,
    meetingAttemptId: string,
    data: ReserveMeetingAttemptRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      MeetingAttemptReservationResultMeetingReservation,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/meeting-attempt/${meetingAttemptId}/reservation`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for claimAMeetingAttemptReservationDepreacted */
  claimAMeetingAttemptReservationDepreactedPathGetter = (tenantId: string, meetingAttemptId: string) =>
    this.getServicePath(`/v1/public/tenant/${tenantId}/meeting-attempt/${meetingAttemptId}/reservation`);

  /**
   * No description
   *
   * @tags Meeting Attempt
   * @name CancelReservationOfMeetingAttempt
   * @request DELETE:/v1/public/tenant/{tenantId}/meeting-attempt/{meetingAttemptId}/reservation/{reservationId}
   */
  cancelReservationOfMeetingAttempt = (
    tenantId: string,
    meetingAttemptId: string,
    reservationId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/meeting-attempt/${meetingAttemptId}/reservation/${reservationId}`,
      method: "DELETE",
      ...params,
    });

  /**
   * @description Returns string containing request path for cancelReservationOfMeetingAttempt */
  cancelReservationOfMeetingAttemptPathGetter = (tenantId: string, meetingAttemptId: string, reservationId: string) =>
    this.getServicePath(
      `/v1/public/tenant/${tenantId}/meeting-attempt/${meetingAttemptId}/reservation/${reservationId}`,
    );

  /**
   * @description Get default availability schedule
   *
   * @tags Availability Schedules
   * @name GetApiV1TenantTenantidUserUseridAvailabilitySchedulesDefault
   * @request GET:/v1/tenant/{tenantId}/user/{userId}/availability-schedules/default
   * @secure
   */
  getApiV1TenantTenantidUserUseridAvailabilitySchedulesDefault = (
    tenantId: string,
    userId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      SchedulePublishedViewDefaultSchedule,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/availability-schedules/default`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidUserUseridAvailabilitySchedulesDefault */
  getApiV1TenantTenantidUserUseridAvailabilitySchedulesDefaultPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/availability-schedules/default`);

  /**
   * @description Get custom availability schedule by id
   *
   * @tags Availability Schedules
   * @name GetApiV1TenantTenantidUserUseridAvailabilitySchedulesScheduleid
   * @request GET:/v1/tenant/{tenantId}/user/{userId}/availability-schedules/{scheduleId}
   * @secure
   */
  getApiV1TenantTenantidUserUseridAvailabilitySchedulesScheduleid = (
    tenantId: string,
    userId: string,
    scheduleId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      SchedulePublishedViewSchedule,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/availability-schedules/${scheduleId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidUserUseridAvailabilitySchedulesScheduleid */
  getApiV1TenantTenantidUserUseridAvailabilitySchedulesScheduleidPathGetter = (
    tenantId: string,
    userId: string,
    scheduleId: string,
  ) => this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/availability-schedules/${scheduleId}`);

  /**
   * @description Create or update custom availability schedule with provided id
   *
   * @tags Availability Schedules
   * @name PutApiV1TenantTenantidUserUseridAvailabilitySchedulesScheduleid
   * @request PUT:/v1/tenant/{tenantId}/user/{userId}/availability-schedules/{scheduleId}
   * @secure
   */
  putApiV1TenantTenantidUserUseridAvailabilitySchedulesScheduleid = (
    tenantId: string,
    userId: string,
    scheduleId: string,
    data: Schedule,
    params: RequestParams = {},
  ) =>
    this.request<
      SchedulePublishedViewSchedule,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/availability-schedules/${scheduleId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for putApiV1TenantTenantidUserUseridAvailabilitySchedulesScheduleid */
  putApiV1TenantTenantidUserUseridAvailabilitySchedulesScheduleidPathGetter = (
    tenantId: string,
    userId: string,
    scheduleId: string,
  ) => this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/availability-schedules/${scheduleId}`);

  /**
   * @description Delete custom availability schedule
   *
   * @tags Availability Schedules
   * @name DeleteApiV1TenantTenantidUserUseridAvailabilitySchedulesScheduleid
   * @request DELETE:/v1/tenant/{tenantId}/user/{userId}/availability-schedules/{scheduleId}
   * @secure
   */
  deleteApiV1TenantTenantidUserUseridAvailabilitySchedulesScheduleid = (
    tenantId: string,
    userId: string,
    scheduleId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/availability-schedules/${scheduleId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteApiV1TenantTenantidUserUseridAvailabilitySchedulesScheduleid */
  deleteApiV1TenantTenantidUserUseridAvailabilitySchedulesScheduleidPathGetter = (
    tenantId: string,
    userId: string,
    scheduleId: string,
  ) => this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/availability-schedules/${scheduleId}`);

  /**
   * @description Get all availability schedules. Endpoint returns default schedule as well. Sorted the following way: default schedule first, then custom schedules sorted by name.
   *
   * @tags Availability Schedules
   * @name GetApiV1TenantTenantidUserUseridAvailabilitySchedules
   * @request GET:/v1/tenant/{tenantId}/user/{userId}/availability-schedules
   * @secure
   */
  getApiV1TenantTenantidUserUseridAvailabilitySchedules = (
    tenantId: string,
    userId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      SchedulePublishedViewSchedule[],
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/availability-schedules`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidUserUseridAvailabilitySchedules */
  getApiV1TenantTenantidUserUseridAvailabilitySchedulesPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/availability-schedules`);

  /**
   * @description Create custom availability schedule
   *
   * @tags Availability Schedules
   * @name PostApiV1TenantTenantidUserUseridAvailabilitySchedules
   * @request POST:/v1/tenant/{tenantId}/user/{userId}/availability-schedules
   * @secure
   */
  postApiV1TenantTenantidUserUseridAvailabilitySchedules = (
    tenantId: string,
    userId: string,
    data: CustomSchedule1,
    params: RequestParams = {},
  ) =>
    this.request<
      SchedulePublishedViewCustomSchedule,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/availability-schedules`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for postApiV1TenantTenantidUserUseridAvailabilitySchedules */
  postApiV1TenantTenantidUserUseridAvailabilitySchedulesPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/availability-schedules`);

  /**
   * @description Returns a map to display availability intervals (linked to AS ids) for specified meeting type
   *
   * @tags Availability Schedules
   * @name GetApiV1TenantTenantidUserUseridAvailabilityMap
   * @request GET:/v1/tenant/{tenantId}/user/{userId}/availability-map
   * @secure
   */
  getApiV1TenantTenantidUserUseridAvailabilityMap = (
    tenantId: string,
    userId: string,
    query: {
      /** @format uuid */
      meetingTypeId: string;
      /** @format date-time */
      intervalStartsAt: string;
      intervalDuration: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      UserAvailabilityMap,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/availability-map`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidUserUseridAvailabilityMap */
  getApiV1TenantTenantidUserUseridAvailabilityMapPathGetter = (
    tenantId: string,
    userId: string,
    query: {
      /** @format uuid */
      meetingTypeId: string;
      /** @format date-time */
      intervalStartsAt: string;
      intervalDuration: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/availability-map`, query);

  /**
   * @description Returns a map to display availability intervals (linked to AS ids) for specified meeting type
   *
   * @tags Availability Schedules
   * @name GetApiV1TenantTenantidAvailabilityMap
   * @request GET:/v1/tenant/{tenantId}/availability-map
   * @secure
   */
  getApiV1TenantTenantidAvailabilityMap = (
    tenantId: string,
    query: {
      /** @minItems 1 */
      userIds: string[];
      /** @format uuid */
      meetingTypeId: string;
      /** @format date-time */
      intervalStartsAt: string;
      intervalDuration: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      UsersAvailabilityMap,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/availability-map`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidAvailabilityMap */
  getApiV1TenantTenantidAvailabilityMapPathGetter = (
    tenantId: string,
    query: {
      /** @minItems 1 */
      userIds: string[];
      /** @format uuid */
      meetingTypeId: string;
      /** @format date-time */
      intervalStartsAt: string;
      intervalDuration: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/availability-map`, query);

  /**
   * @description Returns a list of meeting types which can be assigned to for availability schedules
   *
   * @tags Availability Schedules
   * @name GetAvailableMeetingTypes
   * @request GET:/v1/tenant/{tenantId}/user/{userId}/availability-schedules-available-meeting-types
   * @secure
   */
  getAvailableMeetingTypes = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      AvailableMeetingType[],
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/availability-schedules-available-meeting-types`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getAvailableMeetingTypes */
  getAvailableMeetingTypesPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/availability-schedules-available-meeting-types`);

  /**
   * @description Get all draft availability schedules
   *
   * @tags Availability Schedules Drafts
   * @name GetApiV1TenantTenantidUserUseridAvailabilitySchedulesDrafts
   * @request GET:/v1/tenant/{tenantId}/user/{userId}/availability-schedules-drafts
   * @secure
   */
  getApiV1TenantTenantidUserUseridAvailabilitySchedulesDrafts = (
    tenantId: string,
    userId: string,
    query?: {
      /** @default false */
      compare?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      ScheduleDraftView[],
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/availability-schedules-drafts`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidUserUseridAvailabilitySchedulesDrafts */
  getApiV1TenantTenantidUserUseridAvailabilitySchedulesDraftsPathGetter = (
    tenantId: string,
    userId: string,
    query?: {
      /** @default false */
      compare?: boolean;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/availability-schedules-drafts`, query);

  /**
   * @description Create draft availability schedule
   *
   * @tags Availability Schedules Drafts
   * @name PostApiV1TenantTenantidUserUseridAvailabilitySchedulesDrafts
   * @request POST:/v1/tenant/{tenantId}/user/{userId}/availability-schedules-drafts
   * @secure
   */
  postApiV1TenantTenantidUserUseridAvailabilitySchedulesDrafts = (
    tenantId: string,
    userId: string,
    data: any,
    params: RequestParams = {},
  ) =>
    this.request<
      ScheduleDraftView,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/availability-schedules-drafts`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for postApiV1TenantTenantidUserUseridAvailabilitySchedulesDrafts */
  postApiV1TenantTenantidUserUseridAvailabilitySchedulesDraftsPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/availability-schedules-drafts`);

  /**
   * @description Get draft availability schedule by id
   *
   * @tags Availability Schedules Drafts
   * @name GetApiV1TenantTenantidUserUseridAvailabilitySchedulesDraftsScheduleid
   * @request GET:/v1/tenant/{tenantId}/user/{userId}/availability-schedules-drafts/{scheduleId}
   * @secure
   */
  getApiV1TenantTenantidUserUseridAvailabilitySchedulesDraftsScheduleid = (
    tenantId: string,
    userId: string,
    scheduleId: string,
    query?: {
      /** @default false */
      compare?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      ScheduleDraftView,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/availability-schedules-drafts/${scheduleId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidUserUseridAvailabilitySchedulesDraftsScheduleid */
  getApiV1TenantTenantidUserUseridAvailabilitySchedulesDraftsScheduleidPathGetter = (
    tenantId: string,
    userId: string,
    scheduleId: string,
    query?: {
      /** @default false */
      compare?: boolean;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/availability-schedules-drafts/${scheduleId}`, query);

  /**
   * @description Create or update draft availability schedule
   *
   * @tags Availability Schedules Drafts
   * @name PutApiV1TenantTenantidUserUseridAvailabilitySchedulesDraftsScheduleid
   * @request PUT:/v1/tenant/{tenantId}/user/{userId}/availability-schedules-drafts/{scheduleId}
   * @secure
   */
  putApiV1TenantTenantidUserUseridAvailabilitySchedulesDraftsScheduleid = (
    tenantId: string,
    userId: string,
    scheduleId: string,
    data: any,
    query?: {
      /** @default false */
      compare?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      ScheduleDraftView,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/availability-schedules-drafts/${scheduleId}`,
      method: "PUT",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for putApiV1TenantTenantidUserUseridAvailabilitySchedulesDraftsScheduleid */
  putApiV1TenantTenantidUserUseridAvailabilitySchedulesDraftsScheduleidPathGetter = (
    tenantId: string,
    userId: string,
    scheduleId: string,
    query?: {
      /** @default false */
      compare?: boolean;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/availability-schedules-drafts/${scheduleId}`, query);

  /**
   * @description Delete draft availability schedule
   *
   * @tags Availability Schedules Drafts
   * @name DeleteApiV1TenantTenantidUserUseridAvailabilitySchedulesDraftsScheduleid
   * @request DELETE:/v1/tenant/{tenantId}/user/{userId}/availability-schedules-drafts/{scheduleId}
   * @secure
   */
  deleteApiV1TenantTenantidUserUseridAvailabilitySchedulesDraftsScheduleid = (
    tenantId: string,
    userId: string,
    scheduleId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/availability-schedules-drafts/${scheduleId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteApiV1TenantTenantidUserUseridAvailabilitySchedulesDraftsScheduleid */
  deleteApiV1TenantTenantidUserUseridAvailabilitySchedulesDraftsScheduleidPathGetter = (
    tenantId: string,
    userId: string,
    scheduleId: string,
  ) => this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/availability-schedules-drafts/${scheduleId}`);

  /**
   * No description
   *
   * @tags Availability Toggle
   * @name GetAvailabilityOfUser
   * @request GET:/v1/public/tenant/{tenantId}/availability-toggle/{userId}
   */
  getAvailabilityOfUser = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      UserAvailabilityToggleResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/availability-toggle/${userId}`,
      method: "GET",
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getAvailabilityOfUser */
  getAvailabilityOfUserPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/public/tenant/${tenantId}/availability-toggle/${userId}`);

  /**
   * No description
   *
   * @tags Availability Toggle
   * @name GetAvailabilityOfManyUsers
   * @request GET:/v1/public/tenant/{tenantId}/availability-toggle
   */
  getAvailabilityOfManyUsers = (
    tenantId: string,
    query?: {
      /** @minItems 1 */
      userId?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MapUserIdUserAvailabilityToggleResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/availability-toggle`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getAvailabilityOfManyUsers */
  getAvailabilityOfManyUsersPathGetter = (
    tenantId: string,
    query?: {
      /** @minItems 1 */
      userId?: string[];
    },
  ) => this.getServicePath(`/v1/public/tenant/${tenantId}/availability-toggle`, query);

  /**
   * No description
   *
   * @tags Availability Toggle
   * @name UpdateAvailabilityOfUser
   * @request POST:/v1/tenant/{tenantId}/availability-toggle/{userId}
   * @secure
   */
  updateAvailabilityOfUser = (
    tenantId: string,
    userId: string,
    data: UpdateAvailabilityToggleRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/availability-toggle/${userId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for updateAvailabilityOfUser */
  updateAvailabilityOfUserPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/availability-toggle/${userId}`);

  /**
   * @description Endpoint implemented for Handoff Live and Concierge live calls to check which users are available for a call at a given time. This endpoint does not consider before buffer and MeetingTypeAvailability settings.
   *
   * @tags Product Endpoints
   * @name CheckUsersAvailabilityForAGivenMeetingTypeAndOverrides
   * @request GET:/v1/tenant/{tenantId}/users/live/availability
   * @secure
   */
  checkUsersAvailabilityForAGivenMeetingTypeAndOverrides = (
    tenantId: string,
    query: {
      /** @minItems 1 */
      assigneeIds: string[];
      requiredAttendeeIds?: string[];
      /** @format uuid */
      meetingTypeId: string;
      meetingTypeVersion: string;
      meetingDurationOverride?: string;
      afterBufferDurationOverride?: string;
      /** @format date-time */
      intervalStartsAt: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      CheckFlexibleLiveAvailabilityResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/users/live/availability`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for checkUsersAvailabilityForAGivenMeetingTypeAndOverrides */
  checkUsersAvailabilityForAGivenMeetingTypeAndOverridesPathGetter = (
    tenantId: string,
    query: {
      /** @minItems 1 */
      assigneeIds: string[];
      requiredAttendeeIds?: string[];
      /** @format uuid */
      meetingTypeId: string;
      meetingTypeVersion: string;
      meetingDurationOverride?: string;
      afterBufferDurationOverride?: string;
      /** @format date-time */
      intervalStartsAt: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/users/live/availability`, query);

  /**
   * @description Returns intervals available based on meeting limit
   *
   * @tags Meeting Limit
   * @name PutApiV1TenantTenantidAvailabilityMeetingLimit
   * @request PUT:/v1/tenant/{tenantId}/availability/meeting-limit
   * @secure
   */
  putApiV1TenantTenantidAvailabilityMeetingLimit = (
    tenantId: string,
    data: MeetingLimitRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      MeetingLimitResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/availability/meeting-limit`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for putApiV1TenantTenantidAvailabilityMeetingLimit */
  putApiV1TenantTenantidAvailabilityMeetingLimitPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/availability/meeting-limit`);
}
